import React, { useEffect, useState } from "react";
import time from "../../../assets/svg/time.svg";
import close from "../../../assets/svg/close.svg";
import DOMPurify from "dompurify";
import { createDockSetupApi, getDockGateApi, getUserApi, updateDockSetupApi } from "../master-api";
import { Container, Row, Col } from "react-bootstrap";
import SearchWithAPI from "../../searchbox/searchbox.js";
import AsyncSelect from "react-select/async";

function DockAdd({ dockId, onSuccess, onClose }) {
  const [isClosing, setIsClosing] = useState(false);

  const [description, setDescription] = useState('');

  const handleChange = (e) => {
    setDescription(e.target.value);
  };



  /* useEffect(() => {
    if (show) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
    return () => document.body.classList.remove("modal-open");
  }, [show]); */

  /* if (!show) return null; */

  const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "stretch",
    zIndex: 1050,
    opacity: isClosing ? 0 : 1,
    transition: "opacity 0.3s ease-out",
  };

  const containerStyle = {
    padding: "24px",
    width: "100%",
    maxWidth: "700px",
    backgroundColor: "#fff",
    height: "100vh",
    overflowY: "auto",
    transform: isClosing ? "translateX(100%)" : "translateX(0)",
    transition: "transform 0.3s ease-out",
    animation: "slideInFromRight 0.3s forwards",
  };

  const labelStyle = {
    marginBottom: "6px",
    display: "block",
    fontFamily: "Epilogue",
    fontWeight: "500",
    fontSize: "13px",
    color: "#172B4D",
  };

  const inputStyle = {
    width: "100%",
    padding: "10px",
    borderRadius: "8px",
    height: "40px",
    border: "1px solid #E5E7EB",
    fontSize: "13px",
    fontFamily: "Epilogue",
    fontWeight: "400",
    outline: "none",
    color: "#8790A1",
  };

  const inlineFieldsStyle = {
    display: "flex",
    gap: "16px",
    marginBottom: "20px",
  };

  const timeInputWrapperStyle = {
    position: "relative",
  };

  const timeIconStyle = {
    position: "absolute",
    right: "13px",
    top: "50%",
    transform: "translateY(-50%)",
    width: "17px",
    height: "17px",
  };

  const textareaStyle = {
    width: "100%",
    padding: "10px",
    outline: "none",
    borderRadius: "8px",
    border: "1px solid #E5E7EB",
    fontSize: "14px",
    resize: "none",
    minHeight: "80px",
    color: "#8790A1",
  };

  const actionsStyle = {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    marginTop: "20px",
  };

  const styleTag = (
    <style>
      {`
        @keyframes slideInFromRight {
          from { transform: translateX(100%); }
          to { transform: translateX(0); }
        }
      `}
    </style>
  );

  const apiUrl = process.env.REACT_APP_API_URL;
  const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;
  const [dockCode, setDockCode] = useState("");
  const [dockName, setDockName] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [locationOption, setLocationOption] = useState(null);
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [usersOption, setUsersOption] = useState([]);
  const [validations, setValidations] = useState({
    code: "",
    name: "",
    location_id: "",
    available_in_time: "",
    available_out_time: "",
    description: "",
    display_name: "",
    users: "",
  });

  useEffect(() => {
    if (dockId != null && dockId !== "") {
      getDockEdit();
    }
  }, [dockId]);

  const getDockEdit = async () => {
    try {
      //'sortBy=$sortbyorder&sortByField=$sortbyfiledname&location_id=${filterby[0]['Locationid']}&dock_id=${filterby[0]['dockid']}&dock_type=${filterby[0]['docktypeid']}&vehicletype_id=${filterby[0]['vehicletypeid']}&from_dock_in=${filterby[0]['from_dock_in']}&to_dock_in=${filterby[0]['to_dock_in']}&from_dock_out=${filterby[0]['from_dock_out']}&to_dock_out=&status=${filterby[0]['to_dock_out']}&search=&limit=$itemperpagecount&skip=${currentPages * itemperpagecount}'
      const response = await getDockGateApi(dockId);
      if (response.data.success === true) {
        const dockMaster = response.data.dock;
        setDockCode(dockMaster.code);
        setDockName(dockMaster.name);
        setDisplayName(dockMaster.display_name);
        setLocationOption({ value: dockMaster.location_id, label: dockMaster.location });
        setStartTime(dockMaster.available_in_time);
        setEndTime(dockMaster.available_out_time);
        setUsersOption(dockMaster.users);
        setDescription(dockMaster.description);
        setValidations({
          code: "",
          name: "",
          location_id: "",
          available_in_time: "",
          available_out_time: "",
          description: "",
          display_name: "",
          users: "",
        });
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const handleLocationDropdownChange = (option) => {
    console.log(option);
    setLocationOption(option);
  };
  const fetchOptions = (inputValue, callback) => {
    setTimeout(async () => {
      const response = await getUserApi(inputValue);
      if (response.status === 200) {
        if (response.data.success === true) {
          const options = response.data.suggestionlist.map((item) => ({
            value: String(item.value), // Ensure value is a string
            label: String(item.label), // Ensure label is a string
          }));
          callback(options); // Pass data to react-select
        }
      }
    }, 1000);
  };
  const handleUserDropdownChange = (selectedOptions) => {
    console.log(selectedOptions);
    setUsersOption(selectedOptions);
  };
  const multiselectCustomStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#ffffff",
      borderRadius: "8px",
      border: "0.7px solid #E5E5E5",
      padding: "2px",
      fontWeight: "500",
      fontSize: "13px",
      color: "#212129",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#007bff" : state.isFocused ? "#e0e0e0" : "#fff",
      color: state.isSelected ? "#fff" : "#333",
      padding: 10,
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#F6F7F8",
      color: "#212129",
      borderRadius: "5px",
      padding: "2px 5px",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#212129",
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "#212129",
      cursor: "pointer",
      ":hover": {
        backgroundColor: "red",
        color: "white",
      },
    }),
  };

  const submitDockMaster = async () => {
    const dataBeforeSanitize = {
      id: dockId,
      code: dockCode,
      name: dockName,
      location_id: locationOption != null ? locationOption.value : "",
      available_in_time: startTime,
      available_out_time: endTime,
      description: description,
      display_name: displayName,
      users: usersOption.filter((item) => item.value !== "").map((item) => item.value),
    };
    const dataAfterSanitize = {};
    Object.entries(dataBeforeSanitize).forEach(([key, value]) => {
      if (typeof value === "boolean" || typeof value === "number" || Array.isArray(value) || key === "assignee") {
        dataAfterSanitize[key] = value;
      } else {
        dataAfterSanitize[key] = DOMPurify.sanitize(value);
      }
    });
    if (dockId == null && dockId !== "") {
      const response = await createDockSetupApi(dataAfterSanitize);
      if (response.status === 200) {
        if (response.data.success === true) {
          onSuccess(response.data);
        }
      }
      if (response.status === 400) {
        new Promise((resolve, reject) => {
          const validationTemp = {
            code: "",
            name: "",
            location_id: "",
            available_in_time: "",
            available_out_time: "",
            description: "",
            display_name: "",
            users: "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          console.log("validationTemp...", validationTemp);
          setValidations(validationTemp);
        });
      }
    } else {
      const response = await updateDockSetupApi(dockId, dataAfterSanitize);
      if (response.status === 200) {
        if (response.data.success === true) {
          onSuccess(response.data);
        }
      }
      if (response.status === 400) {
        new Promise((resolve, reject) => {
          const validationTemp = {
            code: "",
            name: "",
            location_id: "",
            available_in_time: "",
            available_out_time: "",
            description: "",
            display_name: "",
            users: "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          console.log("validationTemp...", validationTemp);
          setValidations(validationTemp);
        });
      }
    }
  };
  return (
    <div style={overlayStyle}>
      {styleTag}
      <div style={containerStyle}>
        {/* Header */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
          <h2 style={{ fontSize: "20px", fontWeight: "700", fontFamily: "Epilogue", color: "#172B4D" }}>{dockId != null && dockId !== "" ? "Edit" : "Add"} Dock</h2>
          <button
            style={{
              background: "none",
              border: "1px solid #D4DDE7",
              borderRadius: "100px",
              padding: "8px",
              height: "40px",
              width: "40px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            onClick={onClose} // Use the correct function to close the modal
          >
            <img src={close} alt="close" style={{ width: "14px", height: "14px" }} />
          </button>
        </div>

        {/* Description */}
        <p
          style={{
            fontFamily: "Epilogue",
            fontWeight: "400",
            fontSize: "14px",
            color: "#212129",
            marginBottom: "20px",
            borderBottom: "1px solid #E5E7EB",
            paddingBottom: "20px",
          }}>
          Enter the details below to create a new dock and assign it to the respective person.
        </p>
        <Row className="px-0 mx-0">
          <Col xs={12} sm={12} md={6} className="mt-3 px-0 ps-md-1">
            <div className="field-title mb-1">
              {" "}
              Code<span style={{ color: "#FF4444" }}>*</span>{" "}
            </div>
            <input
              type="text"
              placeholder="Enter here"
              className="input-field mt-1 w-100"
              value={dockCode}
              onChange={(event) => {
                setDockCode(event.target.value); // Update state with input value
              }}
            />
            <span className="field-error">{validations.code}</span>
          </Col>
          <Col xs={12} sm={12} md={6} className="mt-3 px-0 ps-md-1">
            <div className="field-title mb-1">
              {" "}
              Name<span style={{ color: "#FF4444" }}>*</span>{" "}
            </div>
            <input
              type="text"
              placeholder="Enter here"
              className="input-field mt-1 w-100"
              value={dockName}
              onChange={(event) => {
                setDockName(event.target.value); // Update state with input value
              }}
            />
            <span className="field-error">{validations.name}</span>
          </Col>
          <Col xs={12} sm={12} md={6} className="mt-3 px-0 ps-md-1">
            <div className="field-title mb-1">
              {" "}
              Display Name<span style={{ color: "#FF4444" }}>*</span>{" "}
            </div>
            <input
              type="text"
              placeholder="Enter here"
              className="input-field mt-1 w-100"
              value={displayName}
              onChange={(event) => {
                setDisplayName(event.target.value); // Update state with input value
              }}
            />
            <span className="field-error">{validations.display_name}</span>
          </Col>
          <Col xs={12} sm={12} md={6} className="mt-3 px-0 ps-md-1">
            <div className="field-title mb-2">
              {" "}
              Location<span style={{ color: "#FF4444" }}>*</span>{" "}
            </div>
            <SearchWithAPI onDropdownChange={handleLocationDropdownChange} apiUrl={adminApiUrl + "get_location"} params={{}} placeholder={"Select"} selectedOption={locationOption} />
            <span className="field-error">{validations.location_id}</span>
          </Col>
          <Col xs={12} sm={12} md={6} className="mt-3 px-0 ps-md-1">
            <div className="field-title mb-1"> Available From </div>
            <input
              type="time"
              placeholder="Enter here"
              className="input-field mt-1 w-100"
              value={startTime}
              onChange={(event) => {
                setStartTime(event.target.value); // Update state with input value
              }}
            />
            <span className="field-error">{validations.available_in_time}</span>
          </Col>

          <Col xs={12} sm={12} md={6} className="mt-3 px-0 ps-md-1">
            <div className="field-title mb-1"> Available To </div>
            <input
              type="time"
              placeholder="Enter here"
              className="input-field mt-1 w-100"
              value={endTime}
              onChange={(event) => {
                setEndTime(event.target.value); // Update state with input value
              }}
            />
            <span className="field-error">{validations.available_out_time}</span>
          </Col>
          <Col xs={12} sm={12} className="mt-2 px-0">
            <div className="field-title mb-2">User</div>
            <AsyncSelect
              isMulti
              cacheOptions
              value={usersOption}
              loadOptions={fetchOptions}
              onChange={(selectedOptions) => {
                handleUserDropdownChange(selectedOptions);
              }}
              defaultOptions
              placeholder="Search email..."
              styles={multiselectCustomStyles}
              isClearable={false}
            />
            <span className="field-error">{validations.users}</span>
          </Col>

          <Col xs={12} sm={12} className="mt-2 px-0">
            <div className="field-title mb-2">Description</div>
            <textarea value={description} onChange={handleChange} placeholder="Enter your text here..." style={{width:'100%',border:'1px solid #e5e5e5',height:'100px',borderRadius:'8px',padding:'10px',outline:'none',fontWeight:'400',color:'#172b4d',fontSize:'12px'}}>
            </textarea>
            <span className="field-error">{validations.users}</span>
          </Col>
        </Row>

        {/* Footer Buttons */}
        <div style={actionsStyle}>
          <button
            style={{
              padding: "10px 20px",
              backgroundColor: "#FFFFFF",
              border: "1px solid #D1D5DB",
              borderRadius: "12px",
              fontWeight: "600",
              fontSize: "14px",
              cursor: "pointer",
            }}
            onClick={onClose}>
            Cancel
          </button>
          <button
            onClick={submitDockMaster}
            style={{
              padding: "10px 20px",
              backgroundColor: "#EF4444",
              color: "#FFFFFF",
              border: "none",
              borderRadius: "12px",
              fontWeight: "600",
              fontSize: "14px",
              cursor: "pointer",
              fontFamily: "Epilogue",
            }}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
}

export default DockAdd;
